// libraries
import React from 'react'

// components
import SuccessStoriesHero from '../../components/SuccessStoriesHero'
import Section from '../../components/Section'
import RichText from '../../components/RichText'

export interface SuccessStoriesSingleProps {
	title: string
	intro?: string
	theme?: 'light' | 'dark'
}

export default function SuccessStoriesPage({imageSrc, imageSrcSmall, imageSrcMedium, imageSrcLarge, title, taglineHeading, text, intro, author, publishedTime, solutions}) {
	return (
		<>
			<SuccessStoriesHero
				img={imageSrc?.link && {
					srcSmall: imageSrcSmall?.link,
					srcMedium: imageSrcMedium?.link,
					srcLarge: imageSrcLarge?.link,
					src: imageSrc.link,
					alt: imageSrc.alt,
					width: imageSrc.width,
					height: imageSrc.height
				}}
				subtitle={taglineHeading}
				title={title}
				date={publishedTime}
				author={author}
				categories={solutions}
			/>

			<div className='main-content'>
				<Section bgColor='bg-primary' textColor='text-light'>
					<div className='grid-container'>
						<div className='grid-row'>
							<div className='c-xs-12 c-lg-8 start-lg-3'>
								<div className='main-content__intro'>
									<RichText content={`<p>${intro}</p>`}/>
								</div>
								<RichText content={text} />
							</div>
						</div>
					</div>
				</Section>
			</div>
		</>
	)
}